module.exports = __webpack_public_path__ + "media/assets/images/blog/TESTA-LINKEDIN-3logo-6607e1888c7121144f8c3253f69a9b70.jpg";